import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

export default function NavBar({ brand, logo, showManageLink = true }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const goHomeSection = (id) => (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate(`/#${id}`);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.replaceState({}, '', `/#${id}`);
    setIsMobileOpen(false);
  };

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isMobileOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setIsMobileOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isMobileOpen]);

  return (
    <motion.nav
      className="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="nav-container">
        <NavLink className="brand" to="/" aria-label={`${brand} home`}>
          <img className="brand-logo" src={logo} alt="" />
          <span className="brand-name">{brand}</span>
        </NavLink>
        <div className="nav-links">
          <NavLink to="/">Home</NavLink>
          <a href="/#why-marys" onClick={goHomeSection('why-marys')}>
            Why Mary&apos;s
          </a>
          <a href="/#why-us" onClick={goHomeSection('why-us')}>
            Why Us
          </a>
          <a href="/#featured-pups" onClick={goHomeSection('featured-pups')}>
            Featured Pups
          </a>
          <NavLink to="/catalogue">Catalogue</NavLink>
          <NavLink to="/reviews">Reviews</NavLink>
          <NavLink to="/gallery">Gallery</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          {showManageLink ? (
            <NavLink className="nav-owner" to="/manage" title="Owner management">
              Manage
            </NavLink>
          ) : null}
        </div>

        <button
          type="button"
          className="nav-mobile-btn"
          aria-label={isMobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMobileOpen}
          onClick={() => setIsMobileOpen((v) => !v)}
        >
          <span className="nav-mobile-icon" aria-hidden="true" />
        </button>
      </div>

      {isMobileOpen ? (
        <div className="nav-mobile-overlay" role="dialog" aria-label="Menu" onClick={() => setIsMobileOpen(false)}>
          <div className="nav-mobile-panel" onClick={(e) => e.stopPropagation()}>
            <div className="nav-mobile-head">
              <div className="nav-mobile-title">Menu</div>
              <button className="nav-mobile-close" type="button" onClick={() => setIsMobileOpen(false)}>
                ✕
              </button>
            </div>

            <div className="nav-mobile-links">
              <NavLink to="/" onClick={() => setIsMobileOpen(false)}>
                Home
              </NavLink>
              <a href="/#why-marys" onClick={goHomeSection('why-marys')}>
                Why Mary&apos;s
              </a>
              <a href="/#why-us" onClick={goHomeSection('why-us')}>
                Why Us
              </a>
              <a href="/#featured-pups" onClick={goHomeSection('featured-pups')}>
                Featured Pups
              </a>
              <NavLink to="/catalogue" onClick={() => setIsMobileOpen(false)}>
                Catalogue
              </NavLink>
              <NavLink to="/reviews" onClick={() => setIsMobileOpen(false)}>
                Reviews
              </NavLink>
              <NavLink to="/gallery" onClick={() => setIsMobileOpen(false)}>
                Gallery
              </NavLink>
              <NavLink to="/about" onClick={() => setIsMobileOpen(false)}>
                About
              </NavLink>
              <NavLink to="/contact" onClick={() => setIsMobileOpen(false)}>
                Contact
              </NavLink>
              {showManageLink ? (
                <NavLink className="nav-owner" to="/manage" onClick={() => setIsMobileOpen(false)}>
                  Manage
                </NavLink>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </motion.nav>
  );
}
